import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

export const ContentWrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_200};
`
